import React from "react";
import { load } from "../../../config/ckeditor-config";
import { generateRandomKeyIdString } from "lib/utils";
import format from "lib/format";

export default class WysiwygCK extends React.Component {
  componentWillMount() {
    this.uuid = generateRandomKeyIdString();
    this.setState({ value: this.props.initialValue });
    load().then(() => {
      this.setState({ ready: true });
    });
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.props.enabled !== nextProps.enabled) {
      this.toggle(nextProps.enabled !== false);
    }
    if (nextState.ready && !(this.state && this.state.ready)) {
      this.toggle(nextProps.enabled !== false);
    }
  }

  componentWillUnmount() {
    this.disable();
  }

  enable() {
    let { height, toolbar, onBlur, onFocus } = this.props;
    if (this.state.enabled) return;
    this.setState({ enabled: true });
    try {
      CKEDITOR.instances[this.uuid].destroy(true);
    } catch (e) {}

    CKEDITOR.replace(this.uuid, {
      customConfig: CKEDITOR_BASEPATH + "config_luvit.js",
      skin: "moono",
      height: height || "400px",
      toolbar: toolbar || "LUVIT_help",
      filebrowserImageBrowseUrl: format.url(
        "/EnterAdmin.aspx?AdminPage=selectFileForEditor",
      ),
    });

    let ck = CKEDITOR.instances[this.uuid];
    ck.on("change", () => {
      this.setValue(ck.getData());
    });
    ck.on("blur", (e) => {
      this.setValue(ck.getData());
      if (onBlur) onBlur(e);
    });
    ck.on("focus", (e) => {
      if (onFocus) onFocus(e);
    });
  }

  disable() {
    this.setState({ enabled: false });
    try {
      let ck = CKEDITOR.instances[this.uuid];
      if (ck) this.setValue(ck.getData());
      ck.destroy(true);
    } catch (e) {}
  }

  setValue(value) {
    let { onChange } = this.props;
    this.setState({ value });
    if (onChange) {
      onChange({ value });
    }
  }

  toggle(on) {
    on ? this.enable() : this.disable();
  }

  render() {
    let { height } = this.props;
    let { value } = this.state;

    return (
      <textarea
        style={{ display: "none" }}
        id={this.uuid}
        value={value}
        height={height || "400px"}
        onChange={(e) => this.setValue(e)}
      />
    );
  }
}
